export default __webpack_public_path__ + "static/media/Jade 9781846164910.23604650.jpg";